/* @flow */

import React from 'react';
import { Segment, Header } from 'semantic-ui-react';
import ResourceCard from 'shared/components/ResourceCard';
import ResourceVideo from 'shared/components/ResourceVideo';

type Props = {
  content: CatalogPageContent,
  onSerialize?: (content: CatalogPageContent) => void,
};

const Edit = ({ content, onSerialize }: Props) => {
  const resourceSelected = resource =>
    onSerialize({
      ...content,
      resourceId: resource.id,
      resource,
    });

  const resourceDeleted = () =>
    onSerialize({
      ...content,
      resourceId: undefined,
      resource: undefined,
    });

  const children = content.resource ? (
    <ResourceVideo video={content.resource} />
  ) : null;

  return (
    <Segment>
      <Header textAlign="center" content="Vidéo" />
      <ResourceCard
        resourceType="video"
        resource={content.resource}
        onSelected={resourceSelected}
        onDeleted={resourceDeleted}
      >
        {children}
      </ResourceCard>
    </Segment>
  );
};

export default Edit;



// WEBPACK FOOTER //
// ./src/modules/catalog/plugins/video/Edit.js